import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgGrabber = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M15 18C15.5523 18 16 17.5523 16 17C16 16.4477 15.5523 16 15 16C14.4477 16 14 16.4477 14 17C14 17.5523 14.4477 18 15 18ZM16 12C16 12.5523 15.5523 13 15 13C14.4477 13 14 12.5523 14 12C14 11.4477 14.4477 11 15 11C15.5523 11 16 11.4477 16 12ZM9 18C9.55229 18 10 17.5523 10 17C10 16.4477 9.55229 16 9 16C8.44772 16 8 16.4477 8 17C8 17.5523 8.44772 18 9 18ZM9 13C9.55229 13 10 12.5523 10 12C10 11.4477 9.55229 11 9 11C8.44772 11 8 11.4477 8 12C8 12.5523 8.44772 13 9 13ZM16 7C16 7.55229 15.5523 8 15 8C14.4477 8 14 7.55229 14 7C14 6.44772 14.4477 6 15 6C15.5523 6 16 6.44772 16 7ZM9 8C9.55229 8 10 7.55228 10 7C10 6.44772 9.55229 6 9 6C8.44772 6 8 6.44772 8 7C8 7.55229 8.44772 8 9 8Z",
		fill: "var(--colors-grey-1)"
	})
});
export default SvgGrabber;
